import { OnboardingStep } from "../enums";

// Данные о шаге, необходимые для фронта.
// Порядок значения не имеет.
export const OnboardingStepInfoByNumber = new Map<number, any>([
  [OnboardingStep.Funding, { name: "Fund your account", link: "wallet" }],
  [OnboardingStep.Verification, { name: "Identity verification", link: "verification" }],
  [OnboardingStep.Investing, { name: "Invest & Earn", link: "indexes/ripe-index" }]
]);